import * as ReminderService from '@service/ReminderService'
import * as commonItems from './commonItems'

export const namespaced = true

export const state = {
  itemsCount: 0,
  items: [],
  page: 1,
  pageStatus: '',
  item: null,
  logs: []
}

export const mutations = {
  ...commonItems.mutations,
  SET_LOGS(state, logs) {
    state.logs = logs
  }
}

export const actions = {
  ...commonItems.actions,
  // Used for stats
  async fetchReminderLogs({ commit }) {
    try {
      const { data } = await ReminderService.getReminderLogs()
      commit('SET_LOGS', data.payments)
    } catch (ex) {
      console.log(ex)
    }
  }
}
